import { render, staticRenderFns } from "./buyerConfirmOrderInfo.vue?vue&type=template&id=24d564a5&scoped=true"
import script from "./buyerConfirmOrderInfo.vue?vue&type=script&lang=js"
export * from "./buyerConfirmOrderInfo.vue?vue&type=script&lang=js"
import style0 from "./buyerConfirmOrderInfo.vue?vue&type=style&index=0&id=24d564a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d564a5",
  null
  
)

export default component.exports